import { IUsuario } from 'models/Persona';
import { StateCreator, create } from 'zustand'
import { PersistOptions, persist } from "zustand/middleware";

interface UserSate {
    usuario: IUsuario | null
    setUsuario: (usuario: IUsuario) => void
}

export const ususarioStore = create<UserSate>(
    (persist as MyPersist)(
    (set) => ({
        usuario: null,
        setUsuario: (usuario) => set({ usuario }),
    }),
    {
        name: 'metadata', // Nombre del almacenamiento en localStorage
        getStorage: () => sessionStorage, // Puedes cambiar a sessionStorage si lo prefieres
      }
    )
)

type MyPersist = (
    config: StateCreator<UserSate>,
    options: PersistOptions<UserSate>
) => StateCreator<UserSate>;

// interface User {
//     name: string;
//   }
  
//   interface StoreState {
//     user: User | null;
//     setUser: (user: User) => void;
//   }
  
//   const useStore = create<StoreState>(
//     (persist as MyPersist)(
//       (set) => ({
//         user: null,
//         setUser: (user) => set({ user }),
//       }),
//       {
//         name: 'user-storage',
//         getStorage: () => localStorage, // O sessionStorage
//       }
//     )
//   );